import { useTranslation } from "react-i18next";
import { APP_FONT_STACK } from "../utils/common";
import { useState } from "react";
import { toast, Bounce } from "react-toastify";
const DisagreeDialog = ({ open, onCancel, onDisagree, selectedLang }) => {
  const fontFamilyCSS = APP_FONT_STACK;
  const { t } = useTranslation();
  const [disagreeReason, setDisagreeReason] = useState("");
  const [disagreed, setDisagreed] = useState(false)

  const handleDisagree = () => {
    if (disagreeReason.trim() === "") {
      toast.error(t("Please provide a reason for disagreeing"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        style: { fontFamily: fontFamilyCSS },
      });
      return;
    }

    if (!/^[a-zA-Z0-9\s]+$/.test(disagreeReason)) {
      toast.error(t("Reason should only contain letters and numbers"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        style: { fontFamily: fontFamilyCSS },
      });
      return;
    }

    if (disagreeReason.trim().length > 100 && disagreeReason.trim().length < 20) {
      toast.error(t("Reason should be less than 100 characters and more than 20 characters"), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        style: { fontFamily: fontFamilyCSS },
      });
      return;
    }
    setDisagreed(true)
    onDisagree(disagreeReason);
  };
  
  return (
    open && (
      <div
        style={{ zIndex: 999 }}
        className="relative"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          className="fixed inset-0 bg-black-150 opacity-70 transition-opacity"
          aria-hidden="true"
        ></div>

        <div
          style={{ zIndex: 999 }}
          className="fixed inset-0 w-screen overflow-y-auto"
        >
          <div className="flex min-h-full justify-center p-4 text-center items-center">
            <div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all py-12 px-10 w-full max-w-lg">
              <div className="bg-white flex flex-col items-center justify-center">
                <h3
                  style={{ fontFamily: fontFamilyCSS }}
                  className="text-xl font-bold mb-4"
                >
                  {t("Please provide a reason for disagreeing")}
                </h3>
                <textarea
                  style={{ fontFamily: fontFamilyCSS }}
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-150"
                  rows="4"
                  placeholder={t("Enter your reason for disagreeing here...")}
                  value={disagreeReason}
                  onChange={(e) => setDisagreeReason(e.target.value)}
                />
              </div>
              <div className="mt-6 flex items-center justify-center flex-row">
                <button
                  onClick={onCancel}
                  style={{ fontFamily: fontFamilyCSS }}
                  className="bg-gray-300 p-3 rounded-md  font-bold mb-0 text-white mr-2"
                >
                  {t("Cancel")}
                </button>
                <button
                  onClick={handleDisagree}
                  style={{ fontFamily: fontFamilyCSS }}
                  className={`bg-orange-150 p-3 rounded-md font-bold mb-0 text-white ${disagreed && "cursor-not-allowed"}`}
                  disabled={!disagreeReason.trim() || disagreed}
                >
                  {t("Disagree")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default DisagreeDialog;
